import { BaseManagerModel } from '../../util/BaseManagerModel';
import { IArticle } from './types';
import { observable, action, computed, makeObservable } from 'mobx';

export class ArticleManager extends BaseManagerModel<IArticle> {
  @observable isLoadingMore = false; // 是否正在加载更多
  @observable.ref allList: IArticle[] = [];

  @computed
  get hasMore() {
    console.log('hasmore', this.total, this.allList.length);
    return this.total > this.allList.length;
  }

  @action
  setAllList(v: IArticle[]) {
    this.allList = v;
  }

  async initList() {
    await this.list();
    this.allList = this.data;
  }

  @action
  async loadMore() {
    console.log('loadMore', this.hasMore, this.isLoadingMore);
    const nextPage = this.current + 1;
    this.setCurrent(nextPage);
    const result = await this.list();
    console.log('loadMore result', result);
    if (result.items.length > 0) {
      const list = [...this.allList, ...result.items];
      console.log('loadMore result 2', result, list);
      this.setAllList(list);
    }
  }
  constructor() {
    super('article');
    makeObservable(this);
  }
}

export default new ArticleManager();
